<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import Swal from "sweetalert2";
import simplebar from "simplebar-vue";
import OrdersApi from "@/services/orders-api";
import ItemsApi from "@/services/items-api";
import CustomersApi from "@/services/customers-api";
import PricesApi from "@/services/prices-api";
import OrderModal from "@/components/orderModal"
import OrdersList from "@/components/orderslist"
import TopItems from "@/components/topItems";
import Promotions from "@/components/promotion"; 
import {Priviliges} from "../../../privileges";
import UsersApi from "@/services/users-api";

import i18n from "@/i18n";

export default {
  page: {
    title: "Nouvelle Commande",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout, simplebar,OrderModal, OrdersList ,TopItems, Promotions 
  },
  props :{
    brand: {
      type: Object,
      default: () => ({})
    },

    filter: {
      type: String,
    },

    isHomePageRequest: {
      type: Boolean,
      default:false
    },

    isVehiculeSearch: {
      type: Boolean,
      default:false
    },

    isOEMSearch: {
      type: Boolean,
      default:false
    },

    isCompetitorSearch: {
      type: Boolean,
      default:false
    },
  },
  mounted(){
      this.role=sessionStorage.getItem("userr");
      if(sessionStorage.getItem("privileges")!=null){
        this.privileges=sessionStorage.getItem("privileges")
        this.isAdmin=this.privileges.includes(Priviliges[0]["Admin_Role"] )
      }


      if(this.role==0){
        this.getOutstandingInfo()
        this.getCurrentYear()
        this.findItems()
      }

      if(this.role ==1){
        this.getCustomers()
        this.setSimulatedCustomer(true)
      }

      if(this.isHomePageRequest){
        this.isHomePageRequestData=true
        if (this.brand  && this.brand.id && this.brand.name ){
          this.selectedBrand=this.brand.id
          this.selectedBrandName=this.brand.name
        }

        if(this.filter ){
          this.reference = this.filter
        }

      }
      this.getAllBrands()
      this.getManufacturers()
  },
     data () {
        return {
          role:null,
          privileges:"",
          isAdmin:false,
          customerOutstandingInfo:null,
          isGettingCustomerOutstandingInfo: false,
          currentYear:null,
          itemsListFields: [
            // { key:"show_similair", label: "", sortable: false, tdClass:"font-weight-bold align-middle ", thClass:"text-primary ", thStyle:"width:50px;"},
            { key:"ref", thClass:"text-left", tdClass:"text-left font-weight-bold align-middle", },
            { key:"title", thClass:"text-left ", tdClass:"text-left align-middle", thStyle:"width:400px;"},
            { key:"productType", thClass:"text-center", tdClass:"text-left align-middle", thStyle:"width:70px;"},
            { key:"position",thClass:"text-left ", tdClass:"text-left align-middle "},
            { key:"brand",thClass:"text-left", tdClass:"text-left align-middle"},
            { key:"price", thClass:"text-right", tdClass:"text-right font-weight-bold align-middle"},
            { key:"discountStr",thClass:"text-center d-md-table-cell d-none", tdClass:"text-center align-middle font-weight-bold d-md-table-cell d-none"},
            { key:"discountedPrice", thClass:"text-right d-md-table-cell d-none", tdClass:"text-right d-md-table-cell d-none align-middle"},
            { key:"stockStatus",thClass:"text-center", tdClass:"text-center align-middle"},
            { key:"modal",thClass:"text-center", tdClass:"text-center align-middle"},
            { key:"salesUnit", thClass:"text-right", tdClass:"text-right font-weight-bold align-middle"},
            { key:"action", label:"", thStyle:"width:111px;", tdClass:"align-middle"},
            ],
          similairItemsFields:[
            { key:"ref", thClass:"text-left", tdClass:"text-left align-middle"},
            { key:"title", thClass:"text-left", tdClass:"text-left align-middle"},
            { key:"productType", thClass:"text-center", tdClass:"text-left align-middle", thStyle:"width:70px;"},
            { key:"position",thClass:"text-left", tdClass:"text-left align-middle"},
            { key:"brand",thClass:"text-left", tdClass:"text-left align-middle"},
            { key:"price", thClass:"text-right", tdClass:"text-right font-weight-bold align-middle"},
            { key:"discountStr",thClass:"text-center d-md-table-cell d-none", tdClass:"text-center d-md-table-cell d-none font-weight-bold align-middle"},
            { key:"discountedPrice", thClass:"text-right d-md-table-cell d-none", tdClass:"text-right d-md-table-cell d-none align-middle"},
            { key:"stockStatus",thClass:"text-center", tdClass:"text-center align-middle"},
            { key:"modal",thClass:"text-center", tdClass:"text-center align-middle"},
            { key:"salesUnit", thClass:"text-right", tdClass:"text-right font-weight-bold align-middle"},
            { key:"action", label:"", tdClass:"align-middle"},
            ],

          complementaryItemsFields:[
            { key:"ref", thClass:"text-left", tdClass:"text-left align-middle"},
            { key:"title", thClass:"text-left", tdClass:"text-left align-middle"},
            { key:"productType", thClass:"text-center", tdClass:"text-left align-middle", thStyle:"width:70px;"},
            { key:"position",thClass:"text-left", tdClass:"text-left align-middle"},
            { key:"brand",thClass:"text-left", tdClass:"text-left align-middle"},
            { key:"price", thClass:"text-right", tdClass:"text-right font-weight-bold align-middle"},
            { key:"discountStr",thClass:"text-center d-md-table-cell d-none", tdClass:"text-center d-md-table-cell d-none font-weight-bold align-middle"},
            { key:"discountedPrice", thClass:"text-right d-md-table-cell d-none", tdClass:"text-right d-md-table-cell d-none align-middle"},
            { key:"stockStatus",thClass:"text-center", tdClass:"text-center align-middle"},
            { key:"modal",thClass:"text-center", tdClass:"text-center align-middle"},
            { key:"salesUnit", thClass:"text-right", tdClass:"text-right font-weight-bold align-middle"},
            { key:"action", label:"", tdClass:"align-middle"},
            ],
          itemsList:[],
          isTableLoading:false,
          isItemsTableBusy:false,
          pagemodel: {currentPage : 1, perPage : 10, totalRows: 0},
          showDetailsModal:false,
          selectedItem:null,
          filesList:[{id:1,name:"description"},{id:2,name:"fiche technique"}],
          itemsFilter:null,
          
          selectedBrandName:null,
          brandsList:[],
          selectedBrand:null,

          manufacturersList:[],
          selectedManufacturer:null,
          vehiculeModelList:[],
          selectedVehiculeModel:null,
          motorizationTypeList:[],
          selectedMotorizationType:null,
          oemFilter:null,
          competitorsList:[],
          selectedCompetitor:null,
          selectedCompetitorReference:null,
          orderLines: [],
          order: {discountAmount: 0, total: 0, taxes: 0, vat: 0, totalWithTaxes: 0, deliveryAddress:'',totalPara:0,totalPharma:0, totalBeforeDiscount: 0},          
          orderFields: [
            { key:"itemTitle", sortable: true, tdClass:"p-0"},
            { key:"quantity", sortable: false, tdClass:"text-right", thClass:"text-right", thStyle:"width:65px"},
            { key:"price", sortable: false, tdClass:"text-right font-weight-bold", thClass:"text-right", thStyle:"width:100px"},
          ],
          draftFields: [
            {key:"actions", label:""},
            { key:"ref", sortable: false, tdClass:"pt-2"},
            { key:"date", sortable: true, tdClass:"text-right pt-2", thClass:"text-right"},
          ],
          draftLines:[],
          draftsPagination: {currentPage : 1, perPage : 10, totalRows: 0},
          isDraftsTableLoading: false,
          showOrdersDetailsModal:false,
          selectedPriority: { value: 1, name: 'Normale : livraison J+1' },
          optionsPriorities: [
            { value: 0, name: 'Basse : veuillez selectionner la date de livraison souhaitée' },
            { value: 1, name: "Normale : livraison J+1" },
            { value: 2, name: "Urgente: livraison le jour même"  },
          ],
          orderMessage: '',
          isAddToOrderStarting:false,
          oemReference:null,
          reference:null,
          showHistoryModal:false,
          desiredDeliveryDate:null,
          selectedItemOEMsList:[],
          isGettingOemsStarting:false,
          selectedItemManufacturersList:[],
          isGettingItemsManufacturersStarting:false,
          vin:null,
          isCheckingOrder:false,
          promotionCode:null,
          isSimilairItemsTableBusy:false,
          similairItemsList:[],
          similairItemsPagemodel: {currentPage : 1, perPage : 5, totalRows: 0},
          isComplementaryItemsTableBusy: false,
          complementaryItemsList: [],
          complementaryItemsPagemodel: {currentPage : 1, perPage : 5, totalRows: 0},
          showcard:false,
          cardItem:null,
          selectedDeliveryAddress: null,
          isHomePageRequestData:false,
          isPricesTableLoading:false,
          pricesList:[],
          pricesListFields:[
            { key:"sageId", thClass:"text-left", tdClass:"text-left" },
            { key:"code", thClass:"text-left", tdClass:"text-left" },
            { key:"startDate", thClass:"text-left", tdClass:"text-left" },
            { key:"endDate", thClass:"text-left", tdClass:"text-left" },
            { key:"index", thClass:"text-left", tdClass:"text-left" },
            { key:"priority", thClass:"text-left", tdClass:"text-left" },
            { key:"type", thClass:"text-left", tdClass:"text-left" },
            { key:"export", label:"", thClass:"text-right", tdClass:"text-right" },
          ],
          pricesPagemodel:{currentPage : 1, perPage : 10, totalRows: 0},
          exportPricesInProgress:false,
          customersList:[],
          selectedCustomer:null,
          priceFilter:'',
          
          selectedPosition: null,
          optionsPositions:[{name:this.$t('catalog.header.shockAbsorberFilterFront'), value:1}, {name:this.$t('catalog.header.shockAbsorberFilterRear'), value:-1}],


        };
     },
  methods:{

    onRowSelected(item) {
      this.getSimilairItems(item);
      this.getComplementaryItems(item);
    },

    findItemsByReference() {
        this.isTableLoading = true;
        ItemsApi.findItems(this.pagemodel.currentPage, this.pagemodel.perPage,this.selectedBrand,this.reference, this.selectedPosition == null ? null : this.selectedPosition.value)
        .then(itemsList => {
          if(itemsList){
              this.itemsList = itemsList.list
              this.pagemodel.totalRows = itemsList.total;
              this.pagemodel.currentPage = itemsList.page;
              this.pagemodel.perPage = itemsList.pageSize;
              this.pagemodel.pageSize = itemsList.pageSize;
              this.itemsList.forEach(function(item){
                  item.quantity = 1;
              });      
              
              
              //find similair items for the reference
              //if (this.itemsList.length == 0 || this.itemsList.length == 1) {
              //if (this.itemsList.length == 0) {

                if (this.reference) {
                  this.getSimilairItemsByRefCatalog(this.reference);
                  this.getComplementaryItemsByRefCatalog(this.reference);
                }

              //}
          }
        })
        .finally(() => {
        this.isTableLoading = false;

      })

      },
    findItemsByOEM() {
        this.isTableLoading = true;
        ItemsApi.findItemsByOEM(this.pagemodel.currentPage, this.pagemodel.perPage,this.selectedBrand,this.oemReference)
        .then(itemsList => {
          if(itemsList){
          this.itemsList = itemsList.list
          this.pagemodel.totalRows = itemsList.total;
          this.pagemodel.currentPage = itemsList.page;
          this.pagemodel.perPage = itemsList.pageSize;
          this.pagemodel.pageSize = itemsList.pageSize;
          this.itemsList.forEach(function(item){
              item.quantity = 1;
          });          
          }
        })
        .finally(() => {
        this.isTableLoading = false;
        this.isHomePageRequestData=false

      })

      },

    findItemsByVehicules() {
        this.isTableLoading = true;
        ItemsApi.findItemsByVehicules(this.pagemodel.currentPage, this.pagemodel.perPage,this.selectedBrand,
        this.selectedManufacturer==null ? null : this.selectedManufacturer.id ,
        this.selectedVehiculeModel==null ? null : this.selectedVehiculeModel.id ,
        this.selectedMotorizationType==null ? null : this.selectedMotorizationType.id,
        this.selectedPosition == null ? null : this.selectedPosition.value)
        .then(itemsList => {
          if(itemsList){
          this.itemsList = itemsList.list
          this.pagemodel.totalRows = itemsList.total;
          this.pagemodel.currentPage = itemsList.page;
          this.pagemodel.perPage = itemsList.pageSize;
          this.pagemodel.pageSize = itemsList.pageSize;
          this.itemsList.forEach(function(item){
              item.quantity = 1;
          });          
          }
        })
        .finally(() => {
        this.isTableLoading = false;
        this.isHomePageRequestData=false

      })

      },

    findItemsByVIN(){
        this.isTableLoading = true;
        ItemsApi.findItemsByVIN(this.pagemodel.currentPage, this.pagemodel.perPage,this.selectedBrand,this.vin)
        .then(itemsList => {
          if(itemsList){
          this.itemsList = itemsList.list
          this.pagemodel.totalRows = itemsList.total;
          this.pagemodel.currentPage = itemsList.page;
          this.pagemodel.perPage = itemsList.pageSize;
          this.pagemodel.pageSize = itemsList.pageSize;
          this.itemsList.forEach(function(item){
              item.quantity = 1;
          });          
          }
        })
        .finally(() => {
        this.isTableLoading = false;
        this.isHomePageRequestData=false

      })

    },

    findItems(){

      this.similairItemsList = [];
      this.complementaryItemsList = [];
      this.cardItem = null;
      this.similairItemsPagemodel.totalRows = 0;
      this.similairItemsPagemodel.currentPage = 1;

      if(this.oemReference!=null && this.oemReference!=''){
        this.findItemsByOEM()
      }else if(this.selectedManufacturer!=null){
        this.findItemsByVehicules()
      }else if(this.vin!=null && this.vin!=''){
        this.findItemsByVIN()
      }else{
        this.findItemsByReference()
      }
      // if(this.oemReference!=null && this.oemReference!=''){
      //   this.findItemsByOEM()
      // }else{
      //   if(this.selectedManufacturer!=null){
      //     this.findItemsByVehicules()
      //   }else{
      //     this.findItemsByReference()
      //   }
      // }
    },

    getOutstandingInfo(){
      this.isGettingCustomerOutstandingInfo=true
      CustomersApi.getOutstandingInfo().then(
        result =>{
          this.customerOutstandingInfo=result;
          this.isGettingCustomerOutstandingInfo=false;
        }
      ).finally(()=>{
        this.isGettingCustomerOutstandingInfo=false;
      })

    },

    getManufacturers(){
      ItemsApi.getManufacturers().then(
        (result)=>{
          this.manufacturersList=result
        }
      )
    },

    getModels(){
      ItemsApi.getModels(this.selectedManufacturer==null ? null : this.selectedManufacturer.id).then(
        (result)=>{
          this.vehiculeModelList=result
        }
      )
    },

    getVehicules(){
      ItemsApi.getVehicules(this.selectedVehiculeModel==null ? null : this.selectedVehiculeModel.id).then(
        (result)=>{
          this.motorizationTypeList=result
        }
      )
    },

    getCurrentYear(){
        var dt = new Date();
        this.currentYear  = dt.getFullYear();
    },

    getAllBrands(){
        ItemsApi.getAllBrands().then(
            result => {
                this.brandsList=result;
            }
        )
    },

    checkOrder(){
      this.isCheckingOrder=true
      OrdersApi.checkOrder(this.order.id, this.orderMessage, 
      this.selectedPriority==null ? null : this.selectedPriority.value, 
      this.selectedDeliveryAddress==null ? null : this.selectedDeliveryAddress.id,
      false,this.desiredDeliveryDate,this.promotionCode).then(
        (result)=>{
          if(result){
            this.showOrdersDetailsModal =true
          }
        }
      ).finally(
        ()=>{
          this.isCheckingOrder=false
        }
      )
      
    },

    validateDetails(){
      this.showOrdersDetailsModal=false;  
    },

    addToOrder(data) {
      this.$refs['orderLines-tab'].activate()
      this.isAddToOrderStarting=true
      // if(!data.isQuantityChanged && data.quantity==0){
      //   data.quantity=1
      //   data.isQuantityChanged=true
      // }
      OrdersApi.addLineToOrder(this.order.id, data.id, data.quantity,null,false) 
      .then(order => {
        if(order) {
          this.orderLines = order.lines;
          this.order = order; 
        }
        })
        .then(()=>{
          this.isAddToOrderStarting=false
        }).finally(()=>{
          this.isAddToOrderStarting=false
        })
    },

    editOrderLine(item){
      OrdersApi.editLineToOrder(this.order.id, item.itemId, item.editedQuantity, this.selectedSupplier, this.selectedPromotion,false) 
      .then(order => {
        if(order) {
          this.orderLines = order.lines;
          this.order = order; 
        }
      })
      .finally(() => {
        item.isOrderQuantityEdit = false

      }) 

      
    },

    removeOrderLine(item){

        Swal.fire({
        title: i18n.t('order.alerts.delete.title'),
        html: item.itemTitle,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#34c38f",
        cancelButtonText: i18n.t('order.alerts.delete.cancelButtonText'),
        confirmButtonText:  i18n.t('order.alerts.delete.confirmButtonText')
      }).then(result => {
        if (result.value) {
          OrdersApi.removeOrderLine(this.order.id, item.itemId,this.selectedSupplier,false)
          .then(order => {
            if (!order) {
              this.clearAll()
            } else {
              this.orderLines = order.lines;
              this.order = order;
            }
          })
        }
      });
    },


    getOrderLines(draft){
      this.$refs['orderLines-tab'].activate();
      OrdersApi.getOrderLines(draft.id).then(
        order => {
          if (order){
            this.orderLines=order.lines
            this.order=order
          }

        }
      )

  },

    cancelOrder(){
        Swal.fire({
        title: i18n.t('order.alerts.deleteDraft.title'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#34c38f",
        cancelButtonText: i18n.t('order.alerts.deleteDraft.cancelButtonText'),
        confirmButtonText: i18n.t('order.alerts.deleteDraft.confirmButtonText'),
      }).then(result => {
        if(result.value){
          OrdersApi.removeDraft(this.order).then(
            isRemoved => {
              if (isRemoved) {
                  this.clearAll();
              }
            }
          )
        }
      })
    },

    getDrafts(){
      this.isDraftsTableLoading=true
      OrdersApi.getOrdersByCustomer(this.draftsPagination.currentPage, this.draftsPagination.perPage,null, true,0,this.isCurrent,null,null)
      .then(drafts => {
        if(drafts){
        this.draftLines = drafts.list
        this.draftsPagination.totalRows = drafts.total;
        this.draftsPagination.currentPage = drafts.page;
        this.draftsPagination.perPage = drafts.pageSize;
        this.draftsPagination.pageSize = drafts.pageSize;
        }

      })

      .finally(() => {
        this.isDraftsTableLoading=false 
      })
    },
    removeDraft(draft){
        Swal.fire({
        title: i18n.t('order.alerts.deleteDraft.title'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#34c38f",
        cancelButtonText: i18n.t('order.alerts.deleteDraft.cancelButtonText'),
        confirmButtonText: i18n.t('order.alerts.deleteDraft.confirmButtonText')
      }).then(result => {
        if(result.value){
          OrdersApi.removeDraft(draft).then(
            isRemoved => {
              if (isRemoved) {
                 this.getDrafts()
                 this.clearAll();
              }
            }
          )
        }
      })
    },

    clearAll(){
    this.orderLines=[]
    this.order= {discountAmount: 0, total: 0, taxes: 0, vat: 0, totalWithTaxes: 0, deliveryAddress:'',totalPara:0,totalPharma:0, totalBeforeDiscount: 0};
    },

    getItemsOEMs(){
      this.isGettingOemsStarting=true
      ItemsApi.getItemsOEMs(this.selectedItem==null ? null : this.selectedItem.id).then(
        (result)=>{
          this.selectedItemOEMsList=result
        }
      ).finally(
        ()=>{
          this.isGettingOemsStarting=false
        }
      )

    },
    getItemsManufacturers(){
      this.isGettingItemsManufacturersStarting=true;
      this.selectedItemManufacturersList=[]
      ItemsApi.getItemsManufacturers(this.selectedItem==null ? null : this.selectedItem.id).then(
        (result)=>{
          this.selectedItemManufacturersList=result
        }
      ).finally(
        ()=>{
          this.isGettingItemsManufacturersStarting=false
        }
      )
    },

    scrollToCard(){
      //DO NOT DO SCROLLING IN THE NEW VERSION
      /*var elmnt = document.getElementById("similairItemsCard");
      elmnt.scrollIntoView(true); */
    },

    getSimilairItems(items){

      if(items == null ||items.length == 0) {
        return;
      }

      var item = items[0];


      this.cardItem=item
      this.showcard=true
      this.scrollToCard()
      this.isSimilairItemsTableBusy=true
      ItemsApi.getSimilairItems(this.similairItemsPagemodel.currentPage, this.similairItemsPagemodel.perPage,item==null ? null : item.id).then(
        (result)=>{
          if(result){
            this.similairItemsList = result.list
            this.similairItemsPagemodel.totalRows = result.total;
            this.similairItemsPagemodel.currentPage = result.page;
            this.similairItemsPagemodel.perPage = result.pageSize;
            this.similairItemsPagemodel.pageSize = result.pageSize;
            this.similairItemsList.forEach(function(item){
                item.quantity = 1;
            });          
            }
        }
      ).finally(() => {
        this.isSimilairItemsTableBusy = false;

      })
    },

    getSimilairItemsByRefCatalog(refCatalog){

      if(!refCatalog) {
        return;
      }

        this.showcard=true
        this.scrollToCard()
        this.isSimilairItemsTableBusy=true
        ItemsApi.getSimilairItemsByRefCatalog(refCatalog).then(
          (result)=>{
            if(result){

              this.cardItem={ref: refCatalog};

              this.similairItemsList = result.list
              this.similairItemsPagemodel.totalRows = result.total;
              this.similairItemsPagemodel.currentPage = result.page;
              this.similairItemsPagemodel.perPage = result.pageSize;
              this.similairItemsPagemodel.pageSize = result.pageSize;
              this.similairItemsList.forEach(function(item){
                  item.quantity = 1;
              });          
              }
          }
        ).finally(() => {
          this.isSimilairItemsTableBusy = false;

        })
    },

    getComplementaryItems(items){

      if(items == null ||items.length == 0) {
        return;
      }

      var item = items[0];


      this.cardItem=item
      this.showcard=true
      this.scrollToCard()
      this.isComplementaryItemsTableBusy=true
      ItemsApi.getComplementaryItems(this.complementaryItemsPagemodel.currentPage, this.complementaryItemsPagemodel.perPage,item==null ? null : item.id).then(
        (result)=>{
          if(result){
            this.complementaryItemsList = result.list
            this.complementaryItemsPagemodel.totalRows = result.total;
            this.complementaryItemsPagemodel.currentPage = result.page;
            this.complementaryItemsPagemodel.perPage = result.pageSize;
            this.complementaryItemsPagemodel.pageSize = result.pageSize;
            this.complementaryItemsList.forEach(function(item){
                item.quantity = 1;
            });          
            }
        }
      ).finally(() => {
        this.isComplementaryItemsTableBusy = false;

      })
    },


    getComplementaryItemsByRefCatalog(refCatalog){

      if(!refCatalog) {
        return;
      }

      this.showcard=true
      this.scrollToCard()
      this.isComplementaryItemsTableBusy=true
      ItemsApi.getComplementaryItemsByRefCatalog(refCatalog).then(
        (result)=>{
          if(result){
            this.complementaryItemsList = result.list
            this.complementaryItemsPagemodel.totalRows = result.total;
            this.complementaryItemsPagemodel.currentPage = result.page;
            this.complementaryItemsPagemodel.perPage = result.pageSize;
            this.complementaryItemsPagemodel.pageSize = result.pageSize;
            this.complementaryItemsList.forEach(function(item){
                item.quantity = 1;
            });          
            }
        }
      ).finally(() => {
        this.isComplementaryItemsTableBusy = false;

      })
    },

    closeOrderModal(){
        this.showOrdersDetailsModal=false
        this.clearAll();
    },

    downloadPaymentConditions(){
      CustomersApi.downloadPaymentConditions()
    },

    resetPagination(){
          this.pagemodel.currentPage = 1;
    },

    findPrices() {
        this.isPricesTableLoading = true;
        PricesApi.getPrices(this.pricesPagemodel.currentPage, this.pricesPagemodel.perPage,this.priceFilter)
        .then(pricesList => {
          if(pricesList){
            this.pricesList = pricesList.list
            this.pricesPagemodel.totalRows = pricesList.total;
            this.pricesPagemodel.currentPage = pricesList.page;
            this.pricesPagemodel.perPage = pricesList.pageSize;
            this.pricesPagemodel.pageSize = pricesList.pageSize;
            this.isPricesTableLoading = false;         
          }
        })
        .finally(() => {
          this.isPricesTableLoading = false;

      })

    },

    exportCSV(priceId){
        this.exportPricesInProgress = true;
      PricesApi.exportCSV(priceId)
       .then(() => {
           this.exportPricesInProgress = false;
        })
    },

    getCustomers(){
      CustomersApi.getCustomers(null,null).then(
          response => {
          this.customersList=response;
          }
      )
    },

    setSimulatedCustomer(isMounted){
      UsersApi.setSimulatedCustomer(isMounted ? null : this.selectedCustomer==null ? null : this.selectedCustomer.id).then(
        (result)=>{
          if(result){
            this.resetVariables()
            this.findItems()
          }
        }
      )
    },

    getSimulatedCustomer(){
      UsersApi.getSimulatedCustomer().then(
        (result)=>{
          if(result){
            this.selectedCustomer=result
          }
        }
      )
    },

    resetVariables(){
          this.orderLines= []
          this.order= {discountAmount: 0, total: 0, taxes: 0, vat: 0, totalWithTaxes: 0, deliveryAddress:'',totalPara:0,totalPharma:0, totalBeforeDiscount: 0}          
          this.draftLines=[]
          this.draftsPagination= {currentPage : 1, perPage : 10, totalRows: 0}
          this.isDraftsTableLoading= false
          this.showOrdersDetailsModal=false
          this.orderMessage= ''
          this.isAddToOrderStarting=false
          this.desiredDeliveryDate=null
          this.isCheckingOrder=false
          this.promotionCode=null
          this.selectedDeliveryAddress =null
          this.$refs['orderLines-tab'].activate();
    },

    resetSimilars() {
      this.similairItemsList = [];
      this.cardItem = null;
      this.similairItemsPagemodel.totalRows = 0;
      this.similairItemsPagemodel.currentPage = 1;
    },

    typeToColor(lable){
      if(lable=="Amortisseur"){
        return "primary"
      }else if(lable=="Coupelle"){
        return "success"
      }else if(lable=="Kit complet"){
        return "warning"
      }else if(lable=="Patin de ressort"){
        return "info"
      }else if(lable=="Roulement"){
        return "secondary"
      }else{
        return "light"
      }
    },


  },
  computed: {
   computedItemsListFields() {
  
    let isHidePrice = false;

    if (this.selectedCustomer) {
      isHidePrice = this.selectedCustomer.isCe;
    }

    if (this.customerOutstandingInfo) {
      isHidePrice = this.customerOutstandingInfo.isCe;
    }

    return isHidePrice ? this.itemsListFields.filter(field => {
        return field.key !== 'discountStr' && field.key !== 'discountedPrice' && field.key != 'price' && field.key != 'stockStatus';
    }) 
    : this.itemsListFields;
   },

   computedSimilairItemsFields() {

    let isHidePrice = false;

    if (this.selectedCustomer) {
      isHidePrice = this.selectedCustomer.isCe;
    }

    if (this.customerOutstandingInfo) {
      isHidePrice = this.customerOutstandingInfo.isCe;
    }

    return isHidePrice ? this.similairItemsFields.filter(field => {
        return field.key !== 'discountStr' && field.key !== 'discountedPrice' && field.key != 'price' && field.key != 'stockStatus';
    }) 
    : this.similairItemsFields;
   },

    computeComplementaryItemsFields() {

      let isHidePrice = false;

      if (this.selectedCustomer) {
        isHidePrice = this.selectedCustomer.isCe;
      }

      if (this.customerOutstandingInfo) {
        isHidePrice = this.customerOutstandingInfo.isCe;
      }

      return isHidePrice ? this.complementaryItemsFields.filter(field => {
          return field.key !== 'discountStr' && field.key !== 'discountedPrice' && field.key != 'price' && field.key != 'stockStatus';
      }) 
      : this.complementaryItemsFields;
    },

    
  },
  watch :{

    selectedManufacturer: function(){

      this.resetSimilars();

      this.vehiculeModelList=[]
      this.selectedVehiculeModel=null
      this.motorizationTypeList=[]
      this.selectedMotorizationType=null
      if(this.selectedManufacturer!=null){
        this.getModels()
        this.resetPagination();
        this.findItemsByVehicules()
      }else{
        this.resetPagination();
        this.findItems()
      }

    },

    selectedVehiculeModel: function(){

      this.resetSimilars();

      this.motorizationTypeList=[]
      this.selectedMotorizationType=null
      if(this.selectedManufacturer!=null ){
        if(this.selectedVehiculeModel!=null){
          this.getVehicules()
        }
        this.resetPagination();
        this.findItemsByVehicules()
      }
    },

    selectedMotorizationType:function(){

      this.resetSimilars();

      if(this.selectedManufacturer!=null && this.selectedVehiculeModel!=null ){
        this.resetPagination();
        this.findItemsByVehicules();
      }
    },

    'filter':function(){
        this.reference = this.filter
        this.findItems()
    },


    selectedPosition:function(){
        this.findItems();
    },

    selectedCustomer:function(){
      this.setSimulatedCustomer()
    },
    
  }
};

</script>

<style>
    .style-vselect .vs__search {
      line-height: 1;
      color: #394066;
      font-size: 1em
    }

    .style-vselect-position-filter .vs__search::placeholder {
      line-height: 1;
      color: #394066;
      font-size: 1em
    }

    .style-vselect-position-filter .vs__search 
    .style-vselect-position-filter .vs__dropdown-toggle,
    .style-vselect-position-filter .vs__search,
    .style-vselect-position-filter .vs__selected,
    .style-vselect-position-filter .vs__dropdown-menu {
      line-height: 1;
      color: #34c38e;
      font-size: 1em
    }

    .style-vselect-selectedcustomer .vs__search::placeholder,
    .style-vselect-selectedcustomer .vs__dropdown-toggle,
    .style-vselect-selectedcustomer .vs__search,
    .style-vselect-selectedcustomer .vs__dropdown-menu {
      line-height: 1;
      font-size: 1em;
      background: white;
    }

    .style-vselect-selectedcustomer .vs__clear,
    .style-vselect-selectedcustomer .vs__open-indicator {
      fill: #2a2c74;
    }

    #admin .nav-tabs-custom  {
      border-bottom:  2px solid #f6f6f6;
    }

    #notAdmin .nav-tabs-custom  {
    border-bottom:  2px solid #ffffff;
    }

</style>

<template>
<Layout>
  <div>

    <div v-if="role==0" class="row pt-4 d-print-none">
      <div  class ="col-lg-4 col-md-4 col-sm-12 col-xs-12 p-4" >
          <div class="card h-100 ">
            <div class="card-body card  bg-Default">
            <simplebar style="max-height: 12em; min-height:12em">
              <div > 
                <div class="row pl-4 pr-4 pb-3">
                  <div class="col-4 text-left">
                    <div class="mt-3">
                      <p class="text-muted mb-1">{{$t("outstanding.inProgress")}}</p>
                      <h5>{{customerOutstandingInfo.inProgressStr}} </h5>
                    </div>
                  </div>

                  <div class="col-4 text-center">
                    <div class="mt-3">
                      <p class="text-muted mb-1">{{$t("outstanding.ceiling")}}</p>
                      <h5>{{customerOutstandingInfo.ceilingStr}} </h5>
                    </div>
                  </div>

                  <div class="col-4 text-right">
                    <div class="mt-3">
                      <p class="text-muted mb-1">{{$t("outstanding.exceeding")}}</p>
                      <h5 class="text-danger">
                        {{customerOutstandingInfo.exceedingStr}} 
                      </h5>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div :class="customerOutstandingInfo.paymentConditionsPDFExist ? 'col-9' : 'col-12'">
                    <ul class="list-group list-group-flush">
                      <li class="list-group-item">
                        <div class="py-2">
                          <div class="row">
                            <div class="col-6 text-left">
                              <h5 class="font-size-14 text-primary">{{$t("outstanding.status")}}</h5>
                            </div>
                            <div class="col-6 text-right font-size-14 text-muted">{{customerOutstandingInfo.status}}  %
                            </div>
                          </div>
                          <b-progress  
                              :value="customerOutstandingInfo.status" 
                              variant="warning" 
                              height="6px" 
                          />
                          <!-- <div class="progress animated-progess progress-sm">
                            <div
                              class="progress-bar bg-warning"
                              role="progressbar"
                              style="width: 69%"
                              aria-valuenow="69"
                              aria-valuemin="0"
                              aria-valuemax="100"
                            ></div>
                          </div> -->
                        </div>
                      </li>
                    </ul>
                  </div>

                  <div v-if="customerOutstandingInfo.paymentConditionsPDFExist" class="col-3 align-self-center text-center text-primary">
                      <a @click.prevent="downloadPaymentConditions()" :title="$t('outstanding.conditions.hover')" class="font-size-12 font-weight-bold text-center" style="cursor:pointer"><i class="fas fa-download  mr-1"></i>{{$t('outstanding.conditions.label')}} </a> 
                  </div>

                </div>
              </div>
              <div class="text-center" v-if="isGettingCustomerOutstandingInfo" >
                <b-spinner variant="primary" ></b-spinner>
              </div>
            </simplebar>

            </div>
          </div>
      </div>
      <div  class ="col-lg-4 col-md-4 col-sm-12 col-xs-12  p-4" >
          <div class="card  h-100 ">
            <div class="card-body card bg-Defaul">

              <div class="row pt-3 pl-4 pr-4 pb-1">
                <div class="col-9 text-left">
                  <span class="text-muted font-size-14"><i>{{$t("topItems.newOrderTitle.main")}} {{this.currentYear}} <span class="font-size-12"></span></i></span>
                </div>

                <div class="col-3 pl-0 text-right">
                  <a href="javascript:void(0)" class="pl-0" @click="showHistoryModal=true">
                    <h5 class="card-title pb-2 pl-0 font-size-14 text-primary" :title="$t('topItems.historyModal.title')"><i class="fas fa-history  mr-1" /> <span class="font-size-14"></span></h5>
                  </a>
                </div>
              </div> 
             <TopItems :isCatalogPage=true />
            </div>
          </div>
      </div>
      <div class ="col-lg-4 col-md-4 col-sm-12 col-xs-12 p-4" >
          <div class="card  h-100">
            <div class="card-body card  bg-Default">
                <Promotions :isSmall="true" :isCatalogPage="true" />
            </div>
          </div>
      </div>

    </div>
    
    
    <div v-if="role==1" class="row pt-4" >
      <div class="col-12 pr-4 pl-4 pb-2 text-left">
          <span class="text-primary pb-2" style="font-size:1.2em;" > <i class="mdi mdi-eye pr-2 text-primary" style="font-size:15px;"></i>{{$t("catalog.simulatedCustomer.label")}}</span>
      </div>

      <div class="col-12 pr-4 pl-4 text-right">
          <b-form-group label-for="">
              <v-select class="style-vselect-selectedcustomer" style="font-size:1.2em;" :options="customersList" :placeholder="$t('catalog.simulatedCustomer.placeholder')" label="fullCompanyName" v-model="selectedCustomer">
                <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
              </v-select>
            </b-form-group>
      </div>
    </div>

    <div class="row pl-4  d-print-none">
      <div  class ="col-xl-9 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-2 pr-4">
        <div class="card h-100">
          <div class="card-body card border border-warning bg-Default">

            <b-tabs :id="isAdmin ? 'admin' : 'notAdmin'"  class="pb-4 pt-0"   fill justified nav-class="nav-tabs-custom" content-class="p-0 text-muted" align="center" active-nav-item-class="font-weight-bold text-uppercase ">
              <b-tab :title-item-class="isAdmin ? '' : 'd-none'"   lazy   >
                <template v-slot:title>
                    <span class="d-inline-block d-md-none">
                    <i class="fas fa-book font-size-16 "/>
                    </span>
                    <i class="d-none d-md-inline-block fas fa-book  font-size-18 pr-2"/><br/><span class="d-none d-md-inline-block font-size-16">{{$t("catalog.title")}}</span>
                </template>
                  <div class="row pr-4 pl-4" :class="isAdmin ? 'pt-4' : 'pt-3'">
                    <div class="col-xl-9 col-lg-9 col-md-12 col-sm-12 col-xs-12">
                      <h4 class="card-title">{{$t("catalog.title")}}</h4>
                        <p class="card-title-desc d-none d-sm-block">
                          {{$t("catalog.titleDESC.piece1")}} <strong>{{$t("catalog.titleDESC.strong1")}}</strong>, {{$t("catalog.titleDESC.by")}} <strong>{{$t("catalog.titleDESC.strong2")}}</strong>, {{$t("catalog.titleDESC.by")}} <strong>{{$t("catalog.titleDESC.strong3")}}</strong>, {{$t("catalog.titleDESC.by")}} {{$t("catalog.titleDESC.piece2")}} <strong>{{$t("catalog.titleDESC.strong4")}}</strong> {{$t("catalog.titleDESC.or")}} {{$t("catalog.titleDESC.by")}} <strong> {{$t("catalog.titleDESC.strong5")}} </strong>
                        </p>
                    </div>

                    <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-xs-12 text-left text-sm-right pb-2">
                        <b-dropdown class="m-2" :text="selectedBrandName ? selectedBrandName : $t('catalog.filters.brandFilter.all')" :variant="selectedBrand==null ? 'light' : (selectedBrandName.toLowerCase() == 'record' ? 'light' : 'light')" >

                          <template v-slot:button-content>
                            <img
                              v-if="selectedBrandName != null && selectedBrandName.toLowerCase() == 'record'"
                              src="@/assets/images/brand2.png" 
                              alt="user-image"
                              class="mr-2"
                              height="35"
                            />
                            <img
                              v-if="selectedBrandName != null && selectedBrandName.toLowerCase() == 'siaam'"
                              src="@/assets/images/brand1.png" 
                              alt="user-image"
                              class="mr-2"
                              height="35"
                            />
                            <span v-if="selectedBrandName == null"  class="ml-1 text-primary" style="font-size:14px;font-weight:bold;">{{$t('catalog.filters.brandFilter.all')}}</span>
                            <i class="mdi mdi-chevron-down d-none d-xl-inline-block text-primary" style="font-size:15px;"></i>
                          </template>

                            <b-dropdown-item @click="selectedBrand=null;findItems();selectedBrandName =null" >{{$t('catalog.filters.brandFilter.all')}}</b-dropdown-item>
                            <b-dropdown-item v-for="brand in brandsList" 
                                :key="brand.id" 
                                :value="brand.id" 
                                @click="selectedBrand=brand.id; findItems(); selectedBrandName =brand.name; "
                                >{{brand.name}}</b-dropdown-item>
                        </b-dropdown>
                    </div>
                  </div>

                  <div class="row pl-4 pr-4">
                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12  pr-sm-4">
                      <div class="row pb-2">
                        <span class="text-primary  font-weight-bold font-size-14"><i class="fas fa-car pr-2 font-size-14"></i>{{$t("searchFilters.title1")}}</span>
                      </div>
                      <v-select class="style-vselect pb-2  font-size-16"   :options="manufacturersList" v-model="selectedManufacturer" :placeholder="$t('searchFilters.vehicleSearch.placeholders.constructor')" label="name" :disabled="(reference!=null && reference!='') || (oemReference!=null && oemReference!='') || (vin!=null && vin!='')" >
                          <span slot="no-options">{{$t("lists.emptyLists.label")}}</span>
                      </v-select>

                      <v-select class="style-vselect pb-2  font-size-16"   :options="vehiculeModelList" v-model="selectedVehiculeModel" :placeholder="$t('searchFilters.vehicleSearch.placeholders.model')" label="name" :disabled="(reference!=null && reference!='') || (oemReference!=null && oemReference!='') || (vin!=null && vin!='') " >
                        <span slot="no-options">{{$t("lists.emptyLists.label")}}</span>
                      </v-select>
                      
                      <v-select class="style-vselect pb-2 font-size-16"   :options="motorizationTypeList" v-model="selectedMotorizationType" :placeholder="$t('searchFilters.vehicleSearch.placeholders.type')" label="name" :disabled="selectedVehiculeModel == null || (reference!=null && reference!='') || (oemReference!=null && oemReference!='') || (vin!=null && vin!='') " >
                          <span slot="no-options">{{$t("lists.emptyLists.label")}}</span>
                      </v-select> 
                    </div>

                    <div class="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 pr-xs-2 pl-xs-4 pb-3">
                      <div class="row pb-2 pt-3 pt-xl-0 pt-lg-0 pt-md-0">
                        <span class="text-primary pl-xs-4 pr-xs-4 font-weight-bold font-size-14"><i class="fas fa-atlas pr-2 font-size-14"></i>{{$t("searchFilters.title2")}}</span>
                      </div>

                        <div class="row pl-xs-4">

                          <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3 pr-sm-2 align-self-center">
                          
                            <v-select :options="optionsPositions" v-model="selectedPosition" class="style-vselect-position-filter font-weight-bold text-primary font-size-16" :placeholder="$t('catalog.header.shockAbsorberFilter')"  label="name">
                                <span slot="no-options">{{$t("lists.emptyLists.label")}}</span>
                            </v-select> 
                          
                          </div>

                          <div class="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-xs-9 pl-sm-2 pt-3 pt-sm-0 ">
                              <b-input-group>
                                <b-form-input v-model="reference" :placeholder="$t('searchFilters.referenceSearch.reference.placeholder')" @keyup.native.enter="resetPagination();findItems();" :disabled="(oemReference!=null && oemReference!='') || (selectedManufacturer!=null || selectedVehiculeModel!=null || selectedMotorizationType!=null) ||  (vin!=null && vin!='')" 
                                :style="(oemReference!=null && oemReference!='') || (selectedManufacturer!=null || selectedVehiculeModel!=null || selectedMotorizationType!=null) || (vin!=null && vin!='') ? 'background-color:#f2f2f2;' : ''" ></b-form-input>
                                <template v-slot:append>
                                    <b-button  size="sm" variant="warning" @click="resetPagination();findItems();">
                                    <i class="bx bx-search-alt font-weight-bold font-size-16 text-primary align-middle"></i>
                                    </b-button>
                                </template>                            
                            </b-input-group>
                          </div>

                        </div>

                        <div class="row pl-xs-4 pt-2">
                          <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3 pr-sm-2 pt-3 pt-sm-0 align-self-center">
                            <v-select class="style-vselect font-size-16" :placeholder="$t('searchFilters.competitorSarch.brand.placeholder')"  label="name" :disabled="true || (reference!=null && reference!='') || (oemReference!=null && oemReference!='') || (selectedManufacturer!=null || selectedVehiculeModel!=null || selectedMotorizationType!=null) || (vin!=null && vin!='')  ">
                                <span slot="no-options">{{$t("lists.emptyLists.label")}}</span>
                            </v-select> 
                          </div>
                          <div class="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-xs-9 pl-sm-2 pt-2 pt-sm-0">
                            <b-input-group>
                              <b-form-input :placeholder="$t('searchFilters.competitorSarch.reference.placeholder')" @keyup.native.enter="resetPagination();findItems()" :disabled="true || (reference!=null && reference!='') || (oemReference!=null && oemReference!='') || (selectedManufacturer!=null || selectedVehiculeModel!=null || selectedMotorizationType!=null) || (vin!=null && vin!='') " 
                              :style="true || (reference!=null && reference!='') || (oemReference!=null && oemReference!='') || (selectedManufacturer!=null || selectedVehiculeModel!=null || selectedMotorizationType!=null) || (vin!=null && vin!='')  ? 'background-color:#f2f2f2;' : ''" ></b-form-input>
                              <template v-slot:append>
                                  <b-button  size="sm" variant="warning" @click="resetPagination();findItems()">
                                  <i class="bx bx-search-alt font-weight-bold font-size-16 text-primary align-middle"></i>
                                  </b-button>
                              </template>                            
                            </b-input-group>
                          </div>

                        </div>

                        <div class="row pl-xs-4 pt-2">

                          <!-- <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12  pt-3 pt-md-1 pt-sm-2 pt-xs-2 pr-lg-2 ">
                            <b-input-group>
                                <b-form-input v-model="oemReference"  :placeholder="$t('searchFilters.referenceSearch.oem.placeholder')" @keyup.native.enter="resetPagination();findItems()" :disabled="true || (reference!=null && reference!='') || (selectedManufacturer!=null || selectedVehiculeModel!=null || selectedMotorizationType!=null) || (vin!=null && vin!='')" 
                                :style="true || (reference!=null && reference!='') || (selectedManufacturer!=null || selectedVehiculeModel!=null || selectedMotorizationType!=null) || (vin!=null && vin!='')  ? 'background-color:#f2f2f2;' : ''" ></b-form-input>
                          
                                <template v-slot:append>
                                    <b-button  size="sm" variant="warning" @click="resetPagination();findItems()">
                                    <i class="bx bx-search-alt font-weight-bold font-size-16 text-primary align-middle"></i>
                                    </b-button>
                                </template>                            
                              </b-input-group>
                          </div> -->

                          <div class="col-md-12 col-sm-12 col-xs-12 pt-3 pt-md-1 pt-sm-2 pt-xs-2">
                          
                            <b-input-group>
                              <b-form-input :placeholder="$t('searchFilters.vinSearch.placeholder')" v-model="vin" @keyup.native.enter="resetPagination();findItemsByVIN()" :disabled="true || (reference!=null && reference!='') || (oemReference!=null && oemReference!='') || (selectedManufacturer!=null || selectedVehiculeModel!=null || selectedMotorizationType!=null)" 
                              :style="true || (reference!=null && reference!='') || (oemReference!=null && oemReference!='') || (selectedManufacturer!=null || selectedVehiculeModel!=null || selectedMotorizationType!=null) ? 'background-color:#f2f2f2;' : ''" ></b-form-input>
                        
                              <template v-slot:append>
                                  <b-button  size="sm" variant="warning" @click="resetPagination();findItemsByVIN()">
                                  <i class="bx bx-search-alt font-weight-bold font-size-16 text-primary align-middle"></i>
                                  </b-button>
                              </template>                            
                            </b-input-group>
                          
                          </div>

                        </div>

                    </div>

                  </div>

                <div class="table-responsive pt-4">        
                  <b-table 
                  hover
                  :busy="isTableLoading"
                  :items="itemsList"
                  :fields="computedItemsListFields"
                  :perPage="pagemodel.perPage"
                  class="table  "

                  selectable
       select-mode="single"
       selected-variant="info"
       @row-selected="onRowSelected"
                  
                  >
                  <template v-slot:head(ref)>
                    {{ $t("catalog.header.reference") }} 
                  </template>
                  <template v-slot:head(title)>
                    {{ $t("catalog.header.title") }} 
                  </template>
                  <template v-slot:head(position)>
                    {{ $t("catalog.header.shockAbsorberPosition") }} 
                  </template>
                  <template v-slot:head(brand)>
                    {{ $t("catalog.header.brand") }} 
                  </template>
                  <template v-slot:head(price)>
                    {{ $t("catalog.header.price") }} 
                  </template>
                  <template v-slot:head(discountStr)>
                    {{ $t("catalog.header.discount") }} 
                  </template>
                  <template v-slot:head(discountedPrice)>
                    {{ $t("catalog.header.discountedPrice") }} 
                  </template>
                  <template v-slot:head(modal)>
                    {{ $t("catalog.header.modal") }} 
                  </template>
                  <template v-slot:head(salesUnit)>
                    {{ $t("catalog.header.multiple") }} 
                  </template>
                  <template v-slot:head(stockStatus)>
                    {{ $t("catalog.header.stockStatus") }} 
                  </template>
                  <template v-slot:head(productType)>
                    {{ $t("catalog.header.productType") }} 
                  </template>
                  <template v-slot:table-busy>
                    <div class="text-center my-2">
                        <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                    </div>
                  </template>
                  <template v-slot:cell(discountStr)="{value}">
                    {{value == 0 || value ==null ? '_' : value+'%'}} 
                  </template>
                  <template v-slot:cell(price)="{item,value}">
                    <div :class="item.stockStatus == 2 ? 'text-danger' : item.stockStatus == 3 ? '' : 'text-success'">{{value ? value : '_'}} </div>
                  </template>
                  <template v-slot:cell(discountedPrice)="{value}">
                    {{value ? value : '_'}} 
                  </template>
                  <template v-slot:cell(brand)="{value}">
                    {{value.name}} 
                  </template>

                  <template v-slot:cell(productType)="{value}">
                    <h5><b-badge href="#" :variant="typeToColor(value)">{{value}}</b-badge></h5>
                  </template>

                  <template  v-slot:cell(action)="{item}">
                    <div  class="input-group    mb-0" style="width: 7em;" :class="!item.id || (role ==1 && selectedCustomer == null) ? 'd-none' : ''">
                      <b-form-input  type="number" class="no-shadow p-1 form-control form-control-sm font-weight-bold font-size-14 text-right"
                        v-model="item.quantity" @keyup.native.enter="addToOrder(item)"/>
                      <div size="sm" class="input-group-append">
                        <button  type="button"  class="btn input-group-text text-success btn-link btn-sm" @click="addToOrder(item)" :disabled="isAddToOrderStarting"> 
                          <i v-if="!isAddToOrderStarting"  class=" fas fa-plus-circle font-size-14"> </i>
                          <b-spinner v-if="isAddToOrderStarting" small ></b-spinner>
                        </button>
                      </div>
                    </div>

                  </template>
                  <template  v-slot:cell(stockStatus)="{value}">
                          <i v-if="value==2" :title="$t('catalog.stock.notAvailable')" class="fas fa-times-circle text-danger font-size-18"> </i>
                          <div v-else-if="value==3"  class="font-size-18"> _</div>
                          <i v-else :title="$t('catalog.stock.available')" class="fas fa-check-circle  text-success font-size-18"> </i>

                  </template>

                  <!--template v-slot:cell(show_similair)="{item}">
                    <span><i :title="$t('catalog.similairItems.title')" class="fab fa-creative-commons-nd font-size-22 text-warning" style="cursor: pointer; " @click="getSimilairItems(item)" ></i></span>
                  </template-->


                  <template v-slot:cell(modal)="{item}">
                      <i class="far fa-list-alt font-size-18 text-primary" style="cursor:pointer" @click="showDetailsModal=true;selectedItem=item;getItemsManufacturers();" ></i>
                      <!-- fas fa-tasks fas fa-info-circle  far fa-clipboard far fa-list-alt -->
                  </template>
                  </b-table>
                  <span v-if="!isTableLoading && !itemsList.length" class="d-flex justify-content-center m-4 text-danger" >{{ $t("catalog.empty") }} </span>
                </div>
                  <!-- Pagination -->
                  <div class="row pt-3 pl-2 mb-sm-4">
                      <div class="col-sm-8">
                          <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                              <b-form-select @input="findItems()"  v-model="pagemodel.perPage" size="sm" style="width: 5em" :options="[10,15,50,100]"></b-form-select>
                              <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{ $t("pagination.from") }} </span><span class="font-weight-bold"> {{pagemodel.totalRows}} {{ $t("pagination.lines") }}</span></div>
                          </div>
                      </div>
                      <div class="col-sm-4">
                          <div class="dataTables_paginate paging_simple_numbers float-right">
                              <ul class="pagination pagination-rounded mb-0">
                              <b-pagination v-model="pagemodel.currentPage" :per-page="pagemodel.pageSize" :total-rows="pagemodel.totalRows" @input="findItems()" :disabled="isTableLoading" ></b-pagination>
                              </ul>
                          </div>
                      </div>
                  </div> 
                  <!-- Fin Pagination  -->

                  <!-- Similar Items Card start -->
                  <b-card id="similairItemsCard"  no-body header-class="bg-transparent border-secondary" class=" mb-0 mt-4" style="padding=0px;margin=0px; border-radius:5px;">
                    <div class="row" style="background-color:#ffcb02; border-radius: 5px 5px 0px 0px;">
                      <div class="col-12">
                        <h5 class="card-title mt-2 mb-2 text-primary text-center" >{{$t('catalog.similairItems.label')}} {{cardItem ? '[' + cardItem.ref + ']' : ""}}</h5>
                      </div>
                    </div>
                    <div class="table-responsive mb-0">
                      <b-table
                        :striped="true"
                        :small="true"
                        :hover="true"
                        :no-border-collapse="true"
                        :busy="isSimilairItemsTableBusy"
                        :items="similairItemsList"
                        :fields="computedSimilairItemsFields"
                        
                      >
                      <template v-slot:head(ref)>
                        {{ $t("catalog.header.reference") }} 
                      </template>
                      <template v-slot:head(title)>
                        {{ $t("catalog.header.title") }} 
                      </template>
                      <template v-slot:head(position)>
                        {{ $t("catalog.header.shockAbsorberPosition") }} 
                      </template>
                      <template v-slot:head(brand)>
                        {{ $t("catalog.header.brand") }} 
                      </template>
                      <template v-slot:head(price)>
                        {{ $t("catalog.header.price") }} 
                      </template>
                      <template v-slot:head(discountStr)>
                        {{ $t("catalog.header.discount") }} 
                      </template>
                      <template v-slot:head(discountedPrice)>
                        {{ $t("catalog.header.discountedPrice") }} 
                      </template>
                      <template v-slot:head(modal)>
                        {{ $t("catalog.header.modal") }} 
                      </template>
                      <template v-slot:head(salesUnit)>
                        {{ $t("catalog.header.multiple") }} 
                      </template>
                      <template v-slot:head(stockStatus)>
                        {{ $t("catalog.header.stockStatus") }} 
                      </template>
                      <template v-slot:head(productType)>
                        {{ $t("catalog.header.productType") }} 
                      </template>
                      <template v-slot:table-busy>
                        <div class="text-center my-2">
                            <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                        </div>
                      </template>
                      <template v-slot:cell(discountStr)="{value}">
                        {{value == 0 || value ==null ? '_' : value+'%'}} 
                      </template>
                      <template v-slot:cell(price)="{item,value}">
                        <div :class="item.stockStatus == 2 ? 'text-danger' : item.stockStatus == 3 ? '' : 'text-success'">{{value ? value : '_'}} </div>
                      </template>
                      <template v-slot:cell(discountedPrice)="{value}">
                        {{value ? value : '_'}} 
                      </template>
                      <template v-slot:cell(brand)="{value}">
                        {{value.name}} 
                      </template>

                      <template v-slot:cell(productType)="{value}">
                        <h5><b-badge href="#" :variant="typeToColor(value)">{{value}}</b-badge></h5>
                      </template>

                      <template  v-slot:cell(action)="{item}">
                        <div  class="input-group    mb-0" style="width: 7em;"  :class="!item.id || item.id < 0 || (role ==1 && selectedCustomer == null)  ? 'd-none' : ''">
                          <b-form-input  type="number" class="no-shadow p-1 form-control form-control-sm font-weight-bold font-size-14 text-right"
                            v-model="item.quantity" @keyup.native.enter="addToOrder(item)"/>
                          <div size="sm" class="input-group-append">
                            <button  type="button"  class="btn input-group-text text-success btn-link btn-sm" @click="addToOrder(item)" :disabled="isAddToOrderStarting"> 
                              <i v-if="!isAddToOrderStarting"  class=" fas fa-plus-circle font-size-14"> </i>
                              <b-spinner v-if="isAddToOrderStarting" small ></b-spinner>
                            </button>
                          </div>
                        </div>

                      </template>
                      <template  v-slot:cell(stockStatus)="{value}">
                          <i v-if="value==2" :title="$t('catalog.stock.notAvailable')" class="fas fa-times-circle text-danger font-size-18"> </i>
                          <div v-else-if="value==3"  class="font-size-18"> _</div>
                          <i v-else :title="$t('catalog.stock.available')" class="fas fa-check-circle  text-success font-size-18"> </i>
                      </template>
                      <template v-slot:cell(modal)="{item}">
                          <i class="far fa-list-alt font-size-18 text-primary" style="cursor:pointer" @click="showDetailsModal=true;selectedItem=item;getItemsManufacturers();" ></i>
                      </template>
                      </b-table>
                      <span v-if="!isSimilairItemsTableBusy && !similairItemsList.length" class="d-flex justify-content-center m-4 text-danger" >{{ $t("catalog.empty") }} </span>
                      <!-- Pagination -->
                      <!-- <div class="row pt-3 pl-2 mb-sm-4">
                          <div class="col-sm-8">
                              <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                                  <b-form-select @input="getSimilairItems(cardItem)"  v-model="similairItemsPagemodel.perPage" size="sm" style="width: 5em" :options="[5,10]"></b-form-select>
                                  <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{ $t("pagination.from") }} </span><span class="font-weight-bold"> {{similairItemsPagemodel.totalRows}} {{ $t("pagination.lines") }}</span></div>
                              </div>
                          </div>
                          <div class="col-sm-4">
                              <div class="dataTables_paginate paging_simple_numbers float-right">
                                  <ul class="pagination pagination-rounded mb-0">
                                  <b-pagination v-model="similairItemsPagemodel.currentPage" :per-page="similairItemsPagemodel.pageSize" :total-rows="similairItemsPagemodel.totalRows" @input="getSimilairItems(cardItem)" :disabled="isSimilairItemsTableBusy" ></b-pagination>
                                  </ul>
                              </div>
                          </div>
                      </div>  -->
                      <!-- Fin Pagination  -->
                    </div>
        
      
                  </b-card>
                  <!-- Similar Items Card end -->


                  <!-- complementary Items Card start -->
                  <b-card id="similairItemsCard"  no-body header-class="bg-transparent border-secondary" class=" mb-0 mt-4" style="padding=0px;margin=0px; border-radius:5px;">
                    <div class="row" style="background-color:#ffcb02; border-radius: 5px 5px 0px 0px;">
                      <div class="col-12">
                        <h5 class="card-title mt-2 mb-2 text-primary text-center" >{{$t('catalog.complementaryItems.label')}} {{cardItem ? '[' + cardItem.ref + ']' : ""}}</h5>
                      </div>
                    </div>
                    <div class="table-responsive mb-0">
                      <b-table
                        :striped="true"
                        :small="true"
                        :hover="true"
                        :no-border-collapse="true"
                        :busy="isComplementaryItemsTableBusy"
                        :items="complementaryItemsList"
                        :fields="computeComplementaryItemsFields"
                        
                      >
                      <template v-slot:head(ref)>
                        {{ $t("catalog.header.reference") }} 
                      </template>
                      <template v-slot:head(title)>
                        {{ $t("catalog.header.title") }} 
                      </template>
                      <template v-slot:head(position)>
                        {{ $t("catalog.header.shockAbsorberPosition") }} 
                      </template>
                      <template v-slot:head(brand)>
                        {{ $t("catalog.header.brand") }} 
                      </template>
                      <template v-slot:head(price)>
                        {{ $t("catalog.header.price") }} 
                      </template>
                      <template v-slot:head(discountStr)>
                        {{ $t("catalog.header.discount") }} 
                      </template>
                      <template v-slot:head(discountedPrice)>
                        {{ $t("catalog.header.discountedPrice") }} 
                      </template>
                      <template v-slot:head(modal)>
                        {{ $t("catalog.header.modal") }} 
                      </template>
                      <template v-slot:head(salesUnit)>
                        {{ $t("catalog.header.multiple") }} 
                      </template>
                      <template v-slot:head(stockStatus)>
                        {{ $t("catalog.header.stockStatus") }} 
                      </template>
                      <template v-slot:head(productType)>
                        {{ $t("catalog.header.productType") }} 
                      </template>
                      <template v-slot:table-busy>
                        <div class="text-center my-2">
                            <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                        </div>
                      </template>
                      <template v-slot:cell(discountStr)="{value}">
                        {{value == 0 || value ==null ? '_' : value+'%'}} 
                      </template>
                      <template v-slot:cell(price)="{item,value}">
                        <div :class="item.stockStatus == 2 ? 'text-danger' : item.stockStatus == 3 ? '' : 'text-success'">{{value ? value : '_'}} </div>
                      </template>
                      <template v-slot:cell(discountedPrice)="{value}">
                        {{value ? value : '_'}} 
                      </template>
                      <template v-slot:cell(brand)="{value}">
                        {{value.name}} 
                      </template>

                      <template v-slot:cell(productType)="{value}">
                        <h5><b-badge href="#" :variant="typeToColor(value)">{{value}}</b-badge></h5>
                      </template>

                      <template  v-slot:cell(action)="{item}">
                        <div  class="input-group    mb-0" style="width: 7em;"  :class="!item.id || item.id < 0 || (role ==1 && selectedCustomer == null)  ? 'd-none' : ''">
                          <b-form-input  type="number" class="no-shadow p-1 form-control form-control-sm font-weight-bold font-size-14 text-right"
                            v-model="item.quantity" @keyup.native.enter="addToOrder(item)"/>
                          <div size="sm" class="input-group-append">
                            <button  type="button"  class="btn input-group-text text-success btn-link btn-sm" @click="addToOrder(item)" :disabled="isAddToOrderStarting"> 
                              <i v-if="!isAddToOrderStarting"  class=" fas fa-plus-circle font-size-14"> </i>
                              <b-spinner v-if="isAddToOrderStarting" small ></b-spinner>
                            </button>
                          </div>
                        </div>

                      </template>
                      <template  v-slot:cell(stockStatus)="{value}">
                          <i v-if="value==2" :title="$t('catalog.stock.notAvailable')" class="fas fa-times-circle text-danger font-size-18"> </i>
                          <div v-else-if="value==3"  class="font-size-18"> _</div>
                          <i v-else :title="$t('catalog.stock.available')" class="fas fa-check-circle  text-success font-size-18"> </i>
                      </template>
                      <template v-slot:cell(modal)="{item}">
                          <i class="far fa-list-alt font-size-18 text-primary" style="cursor:pointer" @click="showDetailsModal=true;selectedItem=item;getItemsManufacturers();" ></i>
                      </template>
                      </b-table>
                      <span v-if="!isComplementaryItemsTableBusy && !complementaryItemsList.length" class="d-flex justify-content-center m-4 text-danger" >{{ $t("catalog.empty") }} </span>
                    </div>
        
      
                  </b-card>
                  <!-- complementary Items Card end -->

              </b-tab>

              
              <b-tab :title-item-class="isAdmin ? '' : 'd-none'"  lazy @click="findPrices()" >
                <template v-slot:title>
                    <span class="d-inline-block d-md-none">
                    <i class="fas fa-coins font-size-16 "/>
                    </span>
                    <i class="d-none d-md-inline-block fas fa-coins font-size-18 pr-2"/><br/><span class="d-none d-md-inline-block font-size-16">{{$t("catalog.prices")}} </span>
                </template>
                <div class="row pt-4">
                  <div class ="col-12">
                      <b-form-group :label="$t('catalog.priceFilterLabel')" >
                          <b-input-group  >
                              <b-form-input :placeholder="$t('catalog.priceFilterPlaceholder')"   v-model="priceFilter"   @keyup.native.enter="findPrices() "
                                  ></b-form-input>                              
                              <template v-slot:append>
                                  <b-button variant="warning" @click="findPrices()" >
                                  <i class="bx bx-search-alt font-weight-bold font-size-16 text-primary align-middle"></i>
                                  </b-button>
                              </template>
                          </b-input-group>
                      </b-form-group>
                  </div>
                </div>
                <div class="table-responsive pt-2 mt-4">        
                <b-table 
                hover
                :busy="isPricesTableLoading"
                :items="pricesList"
                :fields="pricesListFields"
                :perPage="pricesPagemodel.perPage"
                class="table  "
                
                >
                <template v-slot:table-busy>
                  <div class="text-center my-2">
                      <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                  </div>
                </template>
                <template v-slot:head(sageId)>
                  {{ $t("catalog.pricesLlist.sageId") }} 
                </template>
                <template v-slot:head(code)>
                  {{ $t("catalog.pricesLlist.code") }} 
                </template> 
                 <template v-slot:head(startDate)>
                  {{ $t("catalog.pricesLlist.startDate") }} 
                </template> 
                <template v-slot:head(endDate)>
                  {{ $t("catalog.pricesLlist.endDate") }} 
                </template>
                <template v-slot:head(index)>
                  {{ $t("catalog.pricesLlist.index") }} 
                </template>
                <template v-slot:head(priority)>
                  {{ $t("catalog.pricesLlist.priority") }} 
                </template>
                <template v-slot:head(type)>
                  {{ $t("catalog.pricesLlist.type") }} 
                </template>
                <template v-slot:cell(export)="{item}">
                  <b-button title="Exporter"  size="sm"   variant="outline-primary"  @click.prevent="exportCSV(item.id)" :disabled="exportPricesInProgress"  >
                    <b-spinner small :class="exportPricesInProgress ? 'mr-1' : 'd-none'"></b-spinner>
                    <i class="fas fa-file-excel  font-size-16  font-weight-bold align-middle mr-0 mr-sm-2"></i>
                    <span class=" font-weight-bold text-uppercase d-none d-sm-inline">{{ $t("catalog.pricesLlist.export")}} </span>         
                  </b-button> 
              </template>  
                </b-table>
                <span v-if="!isPricesTableLoading && !pricesList.length" class="d-flex justify-content-center m-4 text-danger" >{{ $t("catalog.pricesLlist.empty") }} </span>
              </div>
              <!-- Pagination -->
              <div class="row pt-3 pl-2 mb-sm-4">
                  <div class="col-sm-8">
                      <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                          <b-form-select @input="findPrices()"  v-model="pricesPagemodel.perPage" size="sm" style="width: 5em" :options="[10,15,50,100]"></b-form-select>
                          <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{ $t("pagination.from") }} </span><span class="font-weight-bold"> {{pricesPagemodel.totalRows}} {{ $t("pagination.lines") }}</span></div>
                      </div>
                  </div>
                  <div class="col-sm-4">
                      <div class="dataTables_paginate paging_simple_numbers float-right">
                          <ul class="pagination pagination-rounded mb-0">
                          <b-pagination v-model="pricesPagemodel.currentPage" :per-page="pricesPagemodel.pageSize" :total-rows="pricesPagemodel.totalRows" @input="findPrices()" :disabled="isPricesTableLoading" ></b-pagination>
                          </ul>
                      </div>
                  </div>
              </div> 
              <!-- Fin Pagination  -->
              </b-tab>
            </b-tabs>


          </div>
        </div>
      </div>
      <div   class="col-xl-3 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-2 pl-xl-3 pr-4">
        <div class="card h-100">
            <div class="card-body card bg-Default">
              <b-tabs fill nav-class="nav-tabs-custom" content-class="p-0 text-muted" align="center" active-nav-item-class="font-weight-bold text-uppercase ">
                <b-tab ref="orderLines-tab"  lazy >
                  <template v-slot:title>
                    <span class="d-inline-block p-0 font-size-14">
                      <i class="fas fa-cart-plus mr-2 font-size-16 text-primary"></i> {{$t('orderTabs.newOrderTab.title')}}
                      <!-- <br><span class="text-primary">Commandes</span> -->
                    </span>
                    <!-- <i class="d-none d-sm-inline-block fas fa-dolly font-size-16 pr-2"/><span class="d-none d-sm-inline-block font-size-16">{{$t('orderTabs.newOrderTab.title')}}</span> -->
                  </template>
                  <div >
                    <div style="min-height: 60em;">
                      <h5 class="card-title mt-3 mb-0 text-secondary text-center">{{$t('orderTabs.newOrderTab.cardTitle')}}</h5>
                      <h6 class="card-title pt-0 mt-1 mb-0 text-success text-center" :class="role==1 ? '' : 'd-none'">{{order.customerName}}</h6><br> 
                      <div class="row pb-3 pt-3">
                        <div class="col-11" >
                        </div>
                        <div class="col-1">
                          <a :title="$t('orderTabs.newOrderTab.clearOderButtonTitle')" href="javascript:void(0);"  @click="cancelOrder()" class="action-icon text-danger">
                          <i class="fas fa-times font-size-14" />
                        </a>  
                        </div>
                      </div>
                      <div class="table-responsive mb-0" >
                        <b-table
                            :striped="true"
                            :small="true"
                            :hover="true"
                            :items="orderLines"
                            :fields="orderFields"
                            sortKey="itemTitle"
                            responsive
                          >
                    <template v-slot:head(itemTitle)>
                      {{ $t("orderTabs.newOrderTab.orderFields.itemTitle") }} 
                    </template>
                    <template v-slot:head(quantity)>
                      {{ $t("orderTabs.newOrderTab.orderFields.quantity") }} 
                    </template>
                    <template v-slot:head(price)>
                      {{ $t("orderTabs.newOrderTab.orderFields.price") }} 
                    </template>
                    <template v-slot:cell(itemTitle)="{item}">
                        <a v-if="!item.isGratuity" :title="$t('parameters.hover.delete')" href="javascript:void(0);"  @click="removeOrderLine(item)" :class="item.id ? '' : 'd-none'" class="action-icon text-danger">
                          <i class="mdi mdi-trash-can font-size-18" />
                        </a>  
                        <i v-if="item.isGratuity" class="fas fa-star text-info font-size-12 " />
                        <span class="text-black ml-2">{{item.ref}}</span>                                          
                    </template>
                    <template v-slot:cell(price)="{item}">
                        <span class="text-black ml-2">{{item.discountedPrice }}</span>                                          
                    </template>
                    <template v-slot:cell(quantity)="{value, item}">
                        <span v-if="!item.isOrderQuantityEdit" class="text-black">{{value}}</span>      
                        <a  v-if="!item.isOrderQuantityEdit && !item.isGratuity" @click="item.isOrderQuantityEdit = true" :title="$t('parameters.hover.editQty')" href="javascript:void(0);" :class="item.itemId ? '' : 'd-none'" class="action-icon text-warning">
                          <i class="fas fa-pencil-alt  ml-2 font-size-13"  @click="item.isOrderQuantityEdit = true; item.editedQuantity = item.quantity;"/>
                        </a>
                        <i v-if="item.isGratuity" class="fas fa-star text-info invisible  ml-2 font-size-12 " />

                        <div v-if="item.isOrderQuantityEdit" class="input-group input-group-sm pull-right mb-0" style="width:85px;">
                          <b-form-input v-model="item.editedQuantity" type="number"  size="sm" class="no-shadow p-1" @keyup.native.enter="editOrderLine(item)"></b-form-input>
                            <div class="input-group-append"  size="sm" >
                              <b-button variant="link"  size="sm" title="Changer la quantité"><i class="font-size-12 fas fa-pencil-alt text-warning" @click="editOrderLine(item)"></i></b-button>
                            </div>
                        </div>
                    </template>
                        </b-table>
                      </div>
                    </div>
                    <div >
                      <div class="table-responsive mt-4" >
                        <table class="table table-centered mb-0 table-nowrap table-sm borderless">
                          <tbody>
                            <tr>
                              <td colspan="3">
                                <h6 class="m-0 text-right font-weight-bold text-right font-weight-bold text-primary">{{$t("orderTabs.newOrderTab.orderSheetFields.total") }}</h6>
                              </td>
                                                                    
                              <td class="text-right text-primary font-weight-bold">{{order.totalBeforeDiscount}}</td>
                            </tr> 
                            <!-- <tr>
                              <td colspan="3">
                                <h6 class="m-0 text-right font-weight-bold text-right font-weight-bold text-primary">{{$t("orderTabs.newOrderTab.orderSheetFields.discountAmount") }}</h6>
                              </td>
                                                                    
                              <td class="text-right text-primary font-weight-bold">{{order.discountAmount}}</td>
                            </tr>  -->
                            <!-- <tr>
                              <td colspan="3">
                                <h6 class="m-0 text-right font-weight-bold text-right">{{$t("orderTabs.newOrderTab.orderSheetFields.total") }}</h6>
                              </td>
                              <td class="text-right">{{order.total}}</td>
                            </tr> -->
                            <tr>
                              <td colspan="3">
                                <h6 class="m-0 text-right">{{$t("orderTabs.newOrderTab.orderSheetFields.discountAmount") }}</h6>
                              </td>
                              <td class="text-right">{{order.discountAmount}}</td>
                            </tr>
                            <!-- <tr>
                              <td colspan="3">
                                <h6 class="m-0 text-right">{{$t("orderTabs.newOrderTab.orderSheetFields.taxes") }}</h6>
                              </td>
                              <td class="text-right">{{order.taxes}}</td>
                            </tr>
                            <tr>
                              <td colspan="3">
                                <h6 class="m-0 text-right">{{$t("orderTabs.newOrderTab.orderSheetFields.vat") }}</h6>
                              </td>
                              <td class="text-right">{{order.vat}}</td>
                            </tr> -->
                            <!-- <tr>
                              <td colspan="3">
                                <h6 class="m-0 text-right font-weight-bold text-primary">{{$t("orderTabs.newOrderTab.orderSheetFields.totalWithTaxes") }}</h6>
                              </td>
                              <td class="text-right text-primary font-weight-bold">{{order.totalWithTaxes}}</td>
                            </tr> -->
                            <tr>
                              <td colspan="3">
                                <h6 class="m-0 text-right font-weight-bold text-primary">{{$t("orderTabs.newOrderTab.orderSheetFields.totalnet") }}</h6>
                              </td>
                              <td class="text-right text-primary font-weight-bold">{{order.total}}</td>
                            </tr>
                          </tbody>
                        </table>
                        <div class="row pb-0 pt-3">
                          <div class="col-sm-12">
                              <b-button variant="danger" style="width:100%" @click="checkOrder()" :disabled="this.isCheckingOrder || !this.orderLines.length"> 
                                <b-spinner small :class="this.isCheckingOrder ? '' : 'd-none'"></b-spinner>
                                <i class="bx bx-check-double font-size-24 align-middle mr-2"></i> <span class="font-weight-bold font-size-14">{{$t("orderTabs.newOrderTab.validateOrderButton") }}</span>
                              </b-button>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </b-tab>
                <!-- <b-tab  lazy >
                  <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                      <i class="fas fa-question font-size-16"></i>
                    </span>
                    <i class="d-none d-sm-inline-block fas fa-question  font-size-16 pr-2"/><span class="d-none d-sm-inline-block font-size-16">{{$t('orderTabs.requestTab.title')}}</span>
                  </template>
                    <h5 class="card-title mt-3 mb-0 text-secondary text-center">{{$t('orderTabs.requestTab.cardTitle')}}</h5><br> 
                </b-tab> -->
                <b-tab @click="getDrafts()" lazy >
                  <template v-slot:title>
                    <span class="d-inline-block ">
                      <i class="fas fa-file-contract font-size-16"></i>
                    </span>
                    <!-- <i class="d-none d-sm-inline-block fas fa-archive font-size-16 pr-2"/><span class="d-none d-sm-inline-block font-size-16">{{$t('orderTabs.draftsTab.title')}}</span> -->
                  </template>
                  <h5 class="card-title mt-3 mb-0 text-secondary text-center">{{$t('orderTabs.draftsTab.cardTitle')}}</h5><br>
                  <div class="table-responsive mb-0" style="min-height:42em;max-height:42em">
                  <b-table
                      :busy="isDraftsTableLoading"
                      :striped="true"
                      :small="true"
                      :hover="true"
                      :items="draftLines"
                      :fields="draftFields"
                      sortKey="date"
                    >
                  <template v-slot:head(ref)>
                    {{ $t("orderTabs.draftsTab.draftFields.ref") }} 
                  </template>
                  <template v-slot:head(date)>
                    {{ $t("orderTabs.draftsTab.draftFields.date") }} 
                  </template>
                  <template v-slot:cell(ref)="{value,item}">
                        <a  title="" href="javascript:void(0);"  @click="getOrderLines(item)" >
                          {{value}}
                        </a>  
                  </template>
                  <template v-slot:cell(actions)="{item}">
                        <a  :title="$t('parameters.hover.delete')" href="javascript:void(0);"  @click="removeDraft(item)" :class="item.id ? '' : 'd-none'" class="action-icon text-danger">
                          <i class="mdi mdi-trash-can font-size-18" />
                        </a>  
                  </template>
                  <template v-slot:table-busy>
                    <div class="text-center m-2">
                        <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
                    </div>
                  </template>
                  </b-table>
                  <span v-if="!isDraftsTableLoading & !draftLines.length" class="d-flex justify-content-center m-4 text-danger" >{{$t("orderTabs.draftsTab.emptyDraftTable")}}</span>
                  <!-- Pagination -->
                  <div class="row pt-3 mb-sm-4">
                      <div class="col-sm-8">
                          <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                              <b-form-select @input="getDrafts()"  v-model="draftsPagination.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
                              <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{$t("pagination.from")}}</span><span class="font-weight-bold"> {{draftsPagination.totalRows}} {{$t("pagination.lines")}}</span></div>
                          </div>
                      </div>
                      <div class="col-sm-4">
                          <div class="dataTables_paginate paging_simple_numbers float-right">
                              <ul class="pagination pagination-rounded mb-0">
                              <b-pagination v-model="draftsPagination.currentPage" :per-page="draftsPagination.pageSize" :total-rows="draftsPagination.totalRows" @input="getDrafts()" :disabled="isDraftsTableLoading" ></b-pagination>
                              </ul>
                          </div>
                      </div>
                  </div> 
                  <!-- Fin Pagination  -->
                  </div> 

                </b-tab>
              </b-tabs>
              
            </div>
        </div>
      </div>
    </div>

    <b-modal v-if="selectedItem"
            v-model="showDetailsModal"
            :title="$t('catalog.modal.title') + ' [' + selectedItem.ref + ']'"
            centered 
            hide-footer
            title-class="text-primary"
            title-tag="h5"
            header-close-variant="danger"
            size="lg">

            <b-tabs fill nav-class="nav-tabs-custom" content-class="p-0 text-muted" align="center" active-nav-item-class="font-weight-bold"> 
              <!-- <b-tabs pills justified content-class="p-3 text-primary"> -->

              <b-tab active :title="$t('catalog.modal.tabs.vehicles-tab.title')" title-item-class="mb-2" style="height:500px;" @click="getItemsManufacturers">
                  <simplebar style="max-height: 500px; min-height:500px">
                    <div class="table-responsive mb-0" style="max-height: 500px; min-height:500px">
                      <table class="table table-nowrap table-centered table-hover" >
                          <tbody>
                              <tr v-for="data  in selectedItemManufacturersList" :key="data.id">
                                <td>
                                  <!-- <span class="text-dark font-weight-16">{{data.manufacturer}}, {{data.model}}, {{data.vehicule}}</span> -->
                                  <span class="text-dark font-weight-16">{{data.manufacturer}} </span>
                                </td>
                                <td>
                                  <span class="text-dark font-weight-16">{{data.model}}</span>
                                </td>
                                <td>
                                  <span class="text-dark font-weight-16">-</span>
                                </td>
                                <td>
                                  <span class="text-dark font-weight-16">-</span>
                                </td>
                                <!-- <td>
                                  <span class="font-weight-16">Essence</span>
                                </td>
                                <td>
                                  <span class="font-weight-16">1990 - 1998</span>
                                </td> -->
                              </tr>
                              
                            <div class="text-center" v-if="isGettingItemsManufacturersStarting" >
                              <b-spinner variant="primary" ></b-spinner>
                            </div>
                            <span v-if="!isGettingItemsManufacturersStarting & !selectedItemManufacturersList.length" class="d-flex justify-content-center m-4 text-danger" >{{$t('catalog.modal.tabs.vehicles-tab.empty')}} </span>
                          </tbody>
                      </table>
                    </div>
                  </simplebar>
              </b-tab>

              <b-tab :title="$t('catalog.modal.tabs.criteria.title')" title-item-class="mb-2" style="height:500px;">
                <span class="d-flex justify-content-center m-4 text-danger" >{{$t("catalog.modal.tabs.criteria.empty")}} </span>
                <!-- <table class="table table-nowrap table-centered table-hover">
                  <tbody>
                    <tr>
                      <td>
                        <span class="text-dark font-weight-bold font-weight-16">EAN</span>
                      </td>
                      <td>
                        <span class="font-weight-16">{{selectedItem==null || !selectedItem.ean ? "Pas défini" : selectedItem.ean}}</span>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <span class="text-dark font-weight-bold font-weight-16">Type d'amortisseur</span>
                      </td>
                      <td>
                        <span class="font-weight-16">{{selectedItem==null || !selectedItem.itemGroup  ? "Pas défini" : selectedItem.itemGroup}} </span>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <span class="text-dark font-weight-bold font-weight-16">Position d'amortisseur</span>
                      </td>
                      <td>
                        <span class="font-weight-16">{{selectedItem==null || !selectedItem.position ? "Pas défini" : selectedItem.position}}</span>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <span class="text-dark font-weight-bold font-weight-16">Nature d'amortisseur</span>
                      </td>
                      <td>
                        <span class="font-weight-16">{{selectedItem==null || !selectedItem.nature  ? "Pas défini" : selectedItem.nature}}</span>
                      </td>
                    </tr>

                  </tbody>
                </table> -->
              </b-tab>

              
          
              <b-tab :title="$t('catalog.modal.tabs.oem-tab.title')" title-item-class="mb-2" style="height:500px;" @click="getItemsOEMs">
                <simplebar style="max-height: 500px; min-height:500px">
                  <div class="table-responsive mb-0" style="max-height: 500px; min-height:500px">
                    <table class="table table-nowrap table-centered table-hover" >
                      <tbody style="height:100%; overflow-y:scroll;">
                        <tr v-for="oem  in selectedItemOEMsList" :key="oem.id">
                          <td>
                            <h5 class="font-size-14 mb-1">
                              <span class="text-dark">{{oem.ref}} </span>
                            </h5>
                            <span class="font-weight-16 text-uppercase">{{oem.manufacturer}}</span>
                          </td>
                        </tr>
                        <div class="text-center" v-if="isGettingOemsStarting" >
                          <b-spinner variant="primary" ></b-spinner>
                        </div>
                        <span v-if="!isGettingOemsStarting & !selectedItemOEMsList.length" class="d-flex justify-content-center m-4 text-danger" >{{$t('catalog.modal.tabs.oem-tab.empty')}} </span>
                      </tbody>
                    </table>
                  </div>
                </simplebar>
              </b-tab>

              <b-tab :title="$t('catalog.modal.tabs.documents-tab.title')" title-item-class="mb-2" style="height:500px;">
                  <!-- <table class="table table-nowrap table-centered table-hover">
                  <tbody>
                    <tr>
                      <td>
                        <i class="fas fa-download font-size-16 align-middle mr-3 text-primary" @click.prevent="exportPDF(file.id)" ></i> 
                        <span class="font-weight-16">Manuel d'Assemblage</span>
                      </td>
                      <td>
                        <span class="font-weight-16">Document Technique</span>
                      </td>
                      <td>
                        <span class="font-weight-16">PDF</span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <i class="fas fa-download font-size-16 align-middle mr-3 text-primary" @click.prevent="exportPDF(file.id)" ></i> 
                        <span class="font-weight-16">Schéma de montage</span>
                      </td>
                      <td>
                        <span class="font-weight-16">Document Technique</span>
                      </td>
                      <td>
                        <span class="font-weight-16">Image</span>
                      </td>
                    </tr>
                  </tbody>
                </table> -->
                  <span  class="d-flex justify-content-center m-4 text-danger" >{{$t('catalog.modal.tabs.documents-tab.empty')}} </span>

              </b-tab>
  
              <b-tab :title="$t('catalog.modal.tabs.images-tab.title')" title-item-class="mb-2" style="height:500px;">
                  <!-- <b-carousel id="carousel1" 
                  controls
                  background="#ababab"
                  :interval="4000">
          
                      <b-carousel-slide :img-src="require('@/assets/images/product/prod1.jpg')" img-width="0px" img-height="0px">
                      </b-carousel-slide>
                  </b-carousel> -->
                  <span  class="d-flex justify-content-center m-4 text-danger" >{{$t('catalog.modal.tabs.images-tab.empty')}} </span>

              </b-tab>
            </b-tabs>


    </b-modal>

    <b-modal
      v-if="order.id "
      v-model="showOrdersDetailsModal"
      title="Valider la commande"
      centered 
      title-class="text-primary d-print-none"
      title-tag="h5"
      header-close-variant="danger"
      header-class="d-print-none"
      class="modal-fullscreen"
      size="xl"
      full-screen
      no-close-on-esc
      hide-footer
      >

      <OrderModal :orderId="this.order.id" v-on:update="closeOrderModal" />
    </b-modal>

    <b-modal
      v-if="role==0"
      v-model="showHistoryModal"
      :title="$t('topItems.historyModal.title')"
      centered 
      title-class="text-primary"
      title-tag="h5"
      header-close-variant="danger"
      hide-footer
      size="lg">
      <OrdersList :isHomePage=true />
    </b-modal>
  </div>

   
</Layout>
</template>



